import React, { useState } from "react";
import { Navbar, Nav, Button, Modal } from "react-bootstrap";

import JSignOut from "./JSignOut";

import "bootstrap/dist/css/bootstrap.min.css";
import FacialRecognitionContainer from "../FacialRecognition/FacialRecognitionContainer";
// import UploadFiles from "../services/UploadFiles";

function CustomNavbar({ username }) {
    const [show, setShow] = useState(false);
    return (
        <div>
            <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
                <Navbar.Brand href="#home">Welcome to Cybercheck | Detect</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                        <div className="button-container">
                            <Modal
                                show={show}
                                onHide={() => setShow(false)}
                                dialogClassName="rekognition-modal"
                                // size="xl"
                                centered={true}
                                animation={true}
                                aria-labelledby="example-custom-modal-styling-title">
                                <Modal.Header closeButton>
                                    <Modal.Title id="example-custom-modal-styling-title">
                                        Age Verification
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <FacialRecognitionContainer />
                                </Modal.Body>
                            </Modal>
                        </div>
                    </Nav>
                    <Nav>
                        <Navbar.Text
                            className="welcome-text d-none d-sm-block"
                            href="#">
                            Welcome {username}
                        </Navbar.Text>
                        <JSignOut />
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
}

export default CustomNavbar;
